import React from "react";

export default function DashBoard() {
  return <div className="dashboard">Dashboard</div>;
}
